import React from "react";
import { Button } from "react-bootstrap";
import "./borderButton.css";

export const BorderButton = ({ text, onClick, disabled, buttonClass }) => {
  return (
    <>
      <Button
        className={`border-button ${buttonClass}`}
        onClick={onClick}
        disabled={disabled}
      >
        {text}
      </Button>
    </>
  );
};
